module.exports = __webpack_public_path__ + "img/prodpage_1.750848f7.png";